<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      persistent
      content-class="dialogContact"
    >
      <v-card class="dialogContact__card rounded-pill">
        <v-btn
          icon
          color="#C0BEBE"
          class="closeBtn"
          @click="dialog = false"
        >
          <v-icon class="fal fa-xmark"></v-icon>
        </v-btn>
        <div class="text-center cardTitle">
          <div class="wrapperIcon">
            <icon name="icon-tick" width="80" height="80"/>
          </div>
          <div>
            <translate class="black--text font-weight-bold text-uppercase cardTitle__label">Thank you for choosing our service</translate>
            <div class="text-uppercase primary--text font-weight-bold mt-2">
              {{pickupData.name}} - {{pickupData.priceMonth}}<translate v-show="pickupData.priceYear">$</translate>
              <translate class="ml-1" v-show="pickupData.priceYear">MONTHLY</translate>
            </div>
          </div>
        </div>
        <div class="text-center centerContact">
          <p v-translate>Please enter your information below. We will get back to you within 24 hours.</p>
        </div>
        <AutoForm
          class="autoForm"
          :layout="layout"
          :model="entity"
          @submit="onSubmit"
          ref="form"
        />
        <v-text-field
          class="checkBotField pt-0"
          v-model="email"
        ></v-text-field>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-col cols="12" :md="12" class="pb-0 d-flex justify-center flex-column align-center">
            <template>
              <vue-recaptcha
                :sitekey="sitekey"
                :loadRecaptchaScript="true"
                @verify="onCaptchaVerified"
                @expired="onCaptchaExpired"
                ref="recaptcha"
              ></vue-recaptcha>
              <v-input
                  v-if="isShowMessage"
                  :error-messages="errorText"
                >
              </v-input>
            </template>
            <v-btn
              color="primary submitSent"
              @click="onSubmit"
              width="130"
              class="rounded-lg my-6 px-8"
              :disabled="!isValidateRecaptcha"
            >
              <translate>Send</translate>
              <icon v-if="isValidateRecaptcha" name="icon-circle-arrow" width="20" height="20" class="ml-4"/>
              <icon v-else name="icon-circel-arrow-default" width="20" height="20" class="ml-4"/>
            </v-btn>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha';
import AutoForm from "@/components/Forms/AutoForm";
import ContactForm from "@/forms/ContactForm";
import ContactService from "@/services/ContactService";
export default {
  name: "ContactForm",
  props: {
    pickupData: {type: Object, default: {}}
  },
  components: {
    VueRecaptcha,
    AutoForm,
    ContactForm
  },
  data() {
    return {
      dialog: true,
      errorText: this.$gettext("Le captcha de vérification est obligatoire"),
      dialogSendContact: false,
      subjectAutres: null,
      sitekey: process.env.VUE_APP_RECAPTCHA_SITE_KEY,
      isValidateRecaptcha: false,
      isShowMessage: false,
      entity: Object.assign({}, ContactForm.defaultEntity),
      email: ''
    };
  },
  computed: {
    layout() {
      return ContactForm.layout(this.entity);
    },
  },
  watch: {
    isValidateRecaptcha() {
      if (this.isValidateRecaptcha == true) {
        this.isShowMessage = false;
      }
    }
  },
  methods: {
    onCaptchaVerified(response) {
      this.isValidateRecaptcha = true;
    },
    onCaptchaExpired () {
      this.$refs.recaptcha.reset();
    },
    async onSubmit() {
      if (this.$refs.form.validate()) {
        let data = {
          civility: this.entity.civility === CONST_MALE ? 'Mr.' : 'Ms.',
        kremmore: this.entity.email,
        companyName: this.entity.companyName,
        fieldOfActivity: this.entity.activity,
        fullname: this.entity.fullname,
        telephone: this.entity.phone,
        pack: `${this.pickupData.name} - ${this.pickupData.priceMonth} monthly`
      }
      const result = await ContactService.sentContact(data)
       if (result.error) {
         this.$toast.alert(result.error.message);
        } else {
          this.$toast.success(`Sent success`);
        }
        this.dialog = false
      }
    },
    open() {
      this.dialog = true
    }
  },
  watch: {
    dialog: {
      handler(val) {
        if(val) {
          this.onCaptchaExpired()
          this.$refs.form.clearForm()
        }
      }
    }
  }
};
</script>
